import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#work", label: "Work" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-brand-bone/95 backdrop-blur border-b border-brand-line"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <a
          href="#home"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="font-display text-xl md:text-2xl font-black tracking-tight text-brand-ink">
            Artisan
          </span>
          <span className="font-display text-xl md:text-2xl font-medium tracking-tight text-brand-rust">
            Contracting
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className="text-sm font-semibold tracking-wide text-brand-ink/80 hover:text-brand-rust transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="tel:17165134765"
          data-testid="header-call-button"
          className="hidden md:inline-flex items-center gap-2 bg-brand-ink text-white px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] hover:bg-brand-rust transition-colors"
        >
          <Phone className="h-3.5 w-3.5" />
          716-513-4765
        </a>

        <button
          data-testid="menu-toggle-button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-brand-ink"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-brand-bone border-t border-brand-line"
        >
          <div className="container-x py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
                className="text-base font-semibold text-brand-ink"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:17165134765"
              data-testid="mobile-call-button"
              className="btn-accent mt-2 w-full"
            >
              <Phone className="h-4 w-4" /> Call 716-513-4765
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
